import React from 'react';
import ContactForm from '../components/contact/index';
import ContactLayout from '../components/layout/ContactLayout';
import { Fade } from 'react-reveal';

export default () => (
  <ContactLayout>
    <section className="pt-10 md:pt-6">
      <div className="container mx-auto md:px-6">
        <div className="text-center lg:text-center">
          <Fade bottom duration={500}>
            <h1 className="animate__animated animate__fadeInUp text-3xl lg:text-6xl text-primary font-bold leading-none">
              Ready to Improve Your Business?
            </h1>
          </Fade>

          <Fade In duration={3000}>
            <h2 className="text-2xl lg:text-4xl text-gray-700 pt-4 font-regular leading-tight">
              Consult FGC is ready to help. Fill out the form below to get in touch with us as well
              as request your Free Website Audit. Or feel free to email us or call with the
              information below:
            </h2>
          </Fade>
        </div>
      </div>
    </section>

    <Fade In duration={1000}>
      <ContactForm />
    </Fade>

    <svg className="hidden lg:block -mb-20" fill="#161e2e" viewBox="0 0 1440 120">
      <path d="M1440,21.2101911 L1440,120 L0,120 L0,21.2101911 C120,35.0700637 240,42 360,42 C480,42 600,35.0700637 720,21.2101911 C808.32779,12.416393 874.573633,6.87702029 918.737528,4.59207306 C972.491685,1.8109458 1026.24584,0.420382166 1080,0.420382166 C1200,0.420382166 1320,7.35031847 1440,21.2101911 Z" />
    </svg>
  </ContactLayout>
);
